import React from 'react';
import type { FC } from 'react';

import { Button, ButtonType } from '@/common/button';
import { FloatingPanel, FloatingPanelItem, FloatingPanelType } from '@/common/floating-panel';
import { TextField, TextFieldType } from '@/common/text-field';
import { useTemplateEditorStore } from '../store';
import { FieldCard } from './field-card';

export interface ImageFieldEditViewProps {
    onClose: () => void;
}

export const ImageFieldEditView: FC<ImageFieldEditViewProps> = ({ onClose }) => {
    const width = useTemplateEditorStore((s) => s.fieldsPanelWidth);
    const handleSave = () => {};

    return (
        <FloatingPanel
            className="pr-4 py-4 h-full flex-shrink-0 overflow-y-auto"
            type={FloatingPanelType.LIGHT}
            width={width}
        >
            <FloatingPanelItem className="flex flex-row justify-between items-center px-4">
                <p className="text-sm text-white font-medium">New Image Field</p>
                <button
                    title="Cancel"
                    className="text-white text-xs font-normal h-5"
                    type="button"
                    onClick={() => onClose()}
                >
                    Cancel
                </button>
            </FloatingPanelItem>

            <FloatingPanelItem className="h-full px-4">
                <div className="flex flex-col gap-3">
                    <div className="flex flex-col gap-1">
                        <p className="text-sm text-white">Field Name</p>
                        <TextField
                            id="imageFieldName"
                            type={TextFieldType.Text}
                            value=""
                            onChange={() => {}}
                            placeholder="Enter Image Field Name"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <p className="text-sm text-white">Layers</p>
                        <div
                            className="p-2 bg-blue-60 bg-opacity-20"
                            onClick={() => {}}
                            onKeyUp={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                }
                            }}
                        >
                            <p className="text-xs text-blue-30">Select an image layer in each frame. </p>
                        </div>
                        {/* any one of above or this will be used */}
                        <FieldCard showMenu={true} showLinkButton={false} isImage={true} />
                    </div>
                    <Button title="Done" buttonType={ButtonType.PRIMARY} onClick={handleSave} />
                </div>
            </FloatingPanelItem>
        </FloatingPanel>
    );
};
